import React, { Component } from "react";
import RugPartsPanel from "./rug/rugPartsPanel";
import RugsWishListSidebar from "./rug/rugsWishListSidebar";
import CarpetBody from "./rug/carpetBody";
import RugAPI from "../api/rug";
import RugsFilterListSidebar from "./rug/rugsFilterListSidebar";
import { densitiesList, shanehList } from "../settings";
import RugTabs from "./rug/rugTabs";
import YourRugTabs from "./rug/yourRugTabs/yourRugTabs";
import SelectPic from "./rug/yourRugTabs/selectPic";
import SelectSize from "./rug/yourRugTabs/SelectSize";
import RugPartsPanelInYourRug from "./rug/rugPartsPanelYourRug";
import ConfirmAndPay from "./rug/yourRugTabs/confirmAndPay";

export default class Feed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCarpetType: "lachak-toranj",
      activePartsTab: "border",
      toranj: null,
      corner: null,
      border: null,
      background: null,

      // Parts:
      defaultItemsLimit: 15,
      //// Toranj
      toranjItems: [],
      toranjItemsOffset: 0,
      toranjItemsError: false,
      toranjItemsLoading: true,
      toranjItemsHasMore: true,
      //// Border
      borderItems: [],
      borderItemsOffset: 0,
      borderItemsError: false,
      borderItemsLoading: true,
      borderItemsHasMore: true,
      //// Background
      backgroundItems: [],
      backgroundItemsOffset: 0,
      backgroundError: false,
      backgroundItemsLoading: true,
      backgroundItemsHasMore: true,
      //// Corner
      cornerItems: [],
      cornerItemsOffset: 0,
      cornerItemsError: false,
      cornerItemsLoading: true,
      cornerItemsHasMore: true,
      //// Tile
      tileItems: [],
      tileItemsOffset: 0,
      tileItemsError: false,
      tileItemsLoading: true,
      tileItemsHasMore: true,
      //// Kheshti Background
      kheshtiBackgroundItems: [],
      kheshtiBackgroundItemsOffset: 0,
      kheshtiBackgroundItemsError: false,
      kheshtiBackgroundItemsLoading: true,
      kheshtiBackgroundItemsHasMore: true,
      //// afshan Background
      afshanBackgroundItems: [],
      afshanBackgroundItemsOffset: 0,
      afshanBackgroundItemsError: false,
      afshanBackgroundItemsHasMore: true,
      afshanBackgroundItemsLoading: true,
      //// Modern Background
      modernBackgroundItems: [],
      modernBackgroundItemsOffset: 0,
      modernBackgroundItemsError: false,
      modernBackgroundItemsLoading: true,
      modernBackgroundItemsHasMore: true,
      //// Modern Pattern
      modernPatternItems: [],
      modernPatternItemsOffset: 0,
      modernPatternItemsError: false,
      modernPatternItemsLoading: true,
      modernPatternItemsHasMore: true,

      activeItems: [],

      // Filters
      densities: [],
      shanehs: [],
      colors: [],
      brands: [],
      yarns: [],

      // Lachak-Toranj States
      lachakToranjSelectedParts: {
        type: "lachak-toranj",
        background: {},
        border: {},
        corner: {},
        toranj: {},
      },
      // Afshan States
      afshanSelectedParts: {
        type: "afshan",
        background: {},
        border: {},
      },
      // KHeshti States
      kheshtiSelectedParts: {
        type: "kheshti",
        background: {},
        tile: {},
      },

      // Modern States
      modernSelectedParts: {
        type: "modern",
        background: {},
        pattern: {},
      },

      // Selected Rugs
      rugsWishList: [],
      // active rugs tab
      activeTabs: "market_rug",
      activeTabInYourRug: "select_size",
      rugsSizeList: [],
      selectedSizeRug: "",
      userInfo: {},
      successPay: false,
      trackingCode: "",
      selectedRugPreview: "",
    };
  }

  wishListHandler = (evt) => {
    evt.preventDefault();
    let newWishList = this.state.rugsWishList;

    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        newWishList.push({ ...this.state.lachakToranjSelectedParts });
        break;
      case "afshan":
        newWishList.push({ ...this.state.afshanSelectedParts });
        break;
      case "modern":
        newWishList.push({ ...this.state.modernSelectedParts });
        break;
      default:
        newWishList.push({ ...this.state.kheshtiSelectedParts });
        break;
    }

    if (newWishList.length > 4) {
      newWishList.shift();
    }

    this.setState({ rugsWishList: newWishList });
  };

  partsClearHandler = (evt) => {
    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        this.setState({
          lachakToranjSelectedParts: {
            type: "lachak-toranj",
            background: {},
            border: {},
            corner: {},
            toranj: {},
          },
        });
        break;
      case "afshan":
        this.setState({
          afshanSelectedParts: {
            type: "afshan",
            background: {},
            border: {},
          },
        });
        break;
      case "modern":
        this.setState({
          modernSelectedParts: {
            type: "modern",
            background: {},
            pattern: {},
          },
        });
        break;
      default:
        this.setState({
          kheshtiSelectedParts: {
            type: "kheshti",
            background: {},
            tile: {},
          },
        });
        break;
    }
  };

  partSelectHandler = (id, image) => {
    const data = {
      id: id,
      image: image,
    };
    let part;
    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        part = this.state.lachakToranjSelectedParts;
        break;
      case "afshan":
        part = this.state.afshanSelectedParts;
        break;
      case "modern":
        part = this.state.modernSelectedParts;
        break;
      default:
        part = this.state.kheshtiSelectedParts;
        break;
    }

    switch (this.state.activePartsTab) {
      case "border":
        part.border = data;
        break;
      case "corner":
        part.corner = data;
        break;
      case "tile":
        part.tile = data;
        break;
      case "toranj":
        part.toranj = data;
        break;
      case "pattern":
        part.pattern = data;
        break;
      default:
        part.background = data;
        break;
    }

    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        this.setState({ lachakToranjSelectedParts: part });
        break;
      case "afshan":
        this.setState({ afshanSelectedParts: part });
        break;
      case "modern":
        this.setState({ modernSelectedParts: part });
        break;
      default:
        this.setState({ kheshtiSelectedParts: part });
        break;
    }
  };

  setParts = (partType, parts) => {
    switch (partType) {
      case "toranj":
        this.setState({
          toranjItems: this.state.toranjItems.concat(parts.results),
          toranjItemsError: false,
          toranjItemsLoading: false,
          toranjItemsHasMore: !!parts.next,
        });
        break;
      case "border":
        this.setState({
          borderItems: this.state.borderItems.concat(parts.results),
          borderItemsError: false,
          borderItemsLoading: false,
          borderItemsHasMore: !!parts.next,
        });
        break;
      case "corner":
        this.setState({
          cornerItems: this.state.cornerItems.concat(parts.results),
          cornerItemsError: false,
          cornerItemsLoading: false,
          cornerItemsHasMore: !!parts.next,
        });
        break;
      case "background":
        this.setState({
          backgroundItems: this.state.backgroundItems.concat(parts.results),
          backgroundItemsError: false,
          backgroundItemsLoading: false,
          backgroundItemsHasMore: !!parts.next,
        });
        break;
      case "afshan_background":
        this.setState({
          afshanBackgroundItems: this.state.afshanBackgroundItems.concat(
            parts.results
          ),
          afshanBackgroundError: false,
          afshanBackgroundItemsLoading: false,
          afshanBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "kheshti_background":
        this.setState({
          kheshtiBackgroundItems: this.state.kheshtiBackgroundItems.concat(
            parts.results
          ),
          kheshtiBackgroundError: false,
          kheshtiBackgroundItemsLoading: false,
          kheshtiBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "modern_background":
        this.setState({
          modernBackgroundItems: this.state.modernBackgroundItems.concat(
            parts.results
          ),
          modernBackgroundError: false,
          modernBackgroundItemsLoading: false,
          modernBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "pattern":
        this.setState({
          modernPatternItems: this.state.modernPatternItems.concat(
            parts.results
          ),
          modernPatternError: false,
          modernPatternItemsLoading: false,
          modernPatternItemsHasMore: !!parts.next,
        });
        break;
      case "tile":
        this.setState({
          tileItems: parts.results,
          tileItemsError: false,
          tileItemsLoading: false,
          tileItemsHasMore: !!parts.next,
        });
        break;
      default:
        break;
    }

    if (partType === this.state.activePartsTab) {
      this.setActiveItems(partType);
    }
  };

  setLoading = (partType) => {
    switch (partType) {
      case "toranj":
        this.setState({
          toranjItemsLoading: true,
        });
        break;
      case "border":
        this.setState({
          borderItemsLoading: true,
        });
        break;
      case "corner":
        this.setState({
          cornerItemsLoading: true,
        });
        break;
      case "background":
        this.setState({
          backgroundItemsLoading: true,
        });
        break;
      case "afshan_background":
        this.setState({
          afshanBackgroundItemsLoading: true,
        });
        break;
      case "kheshti_background":
        this.setState({
          kheshtiBackgroundItemsLoading: true,
        });
        break;
      case "modern_background":
        this.setState({
          modernBackgroundItemsLoading: true,
        });
        break;
      case "pattern":
        this.setState({
          modernPatternItemsLoading: true,
        });
        break;
      case "tile":
        this.setState({
          tileItemsLoading: false,
        });
        break;
      default:
        break;
    }
  };

  getOffset = (partType) => {
    switch (partType) {
      case "toranj":
        return this.state.toranjItemsOffset;
      case "border":
        return this.state.borderItemsOffset;
      case "corner":
        return this.state.cornerItemsOffset;
      case "background":
        return this.state.backgroundItemsOffset;
      case "kheshti_background":
        return this.state.kheshtiBackgroundItemsOffset;
      case "afshan_background":
        return this.state.kheshtiBackgroundItemsOffset;
      case "modern_background":
        return this.state.modernBackgroundItemsOffset;
      case "pattern":
        return this.state.modernPatternItemsOffset;
      case "tile":
        return this.state.tileItemsOffset;
      default:
        return 0;
    }
  };

  loadParts = (partType) => {
    this.setLoading(partType);
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getPartsList(
        partType,
        this.state.brands,
        this.state.yarns,
        this.state.shanehs,
        this.state.densities,
        this.state.colors,
        this.state.defaultItemsLimit,
        this.getOffset(partType)
      )
      .then((response) => {
        if (response.success) {
          this.setParts(partType, response.data);
        } else {
          this.setState({ toranjItemsError: true, toranjItemsLoading: false });
        }
      });
  };

  carpetTypeHandler = (typeName) => {
    if (typeName !== this.state.activeCarpetType) {
      let activePartsTab;
      let items;
      switch (typeName) {
        case "kheshti":
          activePartsTab = "tile";
          items = this.state.tileItems;
          break;
        case "modern":
          activePartsTab = "modern_background";
          items = this.state.modernBackgroundItems;
          break;
        default:
          activePartsTab = "border";
          items = this.state.borderItems;
          break;
      }
      document.getElementById("partsSlider").scrollLeft = 0;
      this.setState({
        activeCarpetType: typeName,
        activePartsTab: activePartsTab,
        activeItems: items,
      });
    }
  };

  partsTabHandler = (tabName) => {
    if (this.state.activePartsTab !== tabName) {
      switch (tabName) {
        case "border":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.borderItems,
          });
          break;
        case "toranj":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.toranjItems,
          });
          break;
        case "corner":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.cornerItems,
          });
          break;
        case "tile":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.tileItems,
          });
          break;
        case "afshan_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.afshanBackgroundItems,
          });
          break;
        case "kheshti_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.kheshtiBackgroundItems,
          });
          break;
        case "modern_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.modernBackgroundItems,
          });
          break;
        case "pattern":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.modernPatternItems,
          });
          break;
        default:
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.backgroundItems,
          });
          break;
      }
      document.getElementById("partsSlider").scrollLeft = 0;
    }
  };

  loadAllParts = () => {
    this.loadParts("toranj");
    this.loadParts("border");
    this.loadParts("corner");
    this.loadParts("background");
    this.loadParts("kheshti_background");
    this.loadParts("afshan_background");
    this.loadParts("modern_background");
    this.loadParts("pattern");
    this.loadParts("tile");
  };

  setActiveItems = (activeTab) => {
    switch (activeTab) {
      case "border":
        this.setState({ activeItems: this.state.borderItems });
        break;
      case "corner":
        this.setState({ activeItems: this.state.cornerItems });
        break;
      case "background":
        this.setState({ activeItems: this.state.backgroundItems });
        break;
      case "toranj":
        this.setState({ activeItems: this.state.toranjItems });
        break;
      case "tile":
        this.setState({ activeItems: this.state.tileItems });
        break;
      case "afshan_background":
        this.setState({ activeItems: this.state.afshanBackgroundItems });
        break;
      case "kheshti_background":
        this.setState({ activeItems: this.state.kheshtiBackgroundItems });
        break;
      case "modern_background":
        this.setState({ activeItems: this.state.modernBackgroundItems });
        break;
      case "pattern":
        this.setState({ activeItems: this.state.modernPatternItems });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const page = queryParams.get("page");
    const tab = queryParams.get("tabs");
    const selected_rug_in_preview = this.props?.context?.location?.state?.image;
    this.selectTabs(page);
    // this.loadAllParts();
    this.rugSize();
    this.setState({
      activeTabs: page,
      selectedRugPreview: selected_rug_in_preview,
    });
    if (tab) {
      this.selectTabInYourRug(tab);
    }
  }

  rugSize = () => {
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getRugSize()
      .then((res) => {
        this.setState({ rugsSizeList: res.data });
      })
      .catch(() => {});
  };

  requestRug = () => {
    let imagesSelected;
    if (this.state.selectedRugPreview) {
      imagesSelected = Object.values(this.state.selectedRugPreview)
        .map((m) => {
          if (m.image) return m.image;
        })
        .toString();
    }

    const rugAPIObj = new RugAPI();
    let data = new FormData();
    data.append("size", this.state.selectedSizeRug.id);
    data.append("national_id", "1111111111");
    data.append("image", this.state.userInfo.image);
    data.append("name", this.state.userInfo.name);
    data.append("phone", this.state.userInfo.phone);
    data.append(
      "address",
      `${this.state.userInfo.address} ${
        imagesSelected ? `iamges : ${imagesSelected}` : ""
      }`
    );
    rugAPIObj
      .requestForRug(data)
      .then((res) => {
        this.setState({ trackingCode: res.data.code });
        this.setState({ successPay: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  addOrRemoveFromArray = (arr, value) => {
    let finalArray = arr;
    if (arr.indexOf(value) === -1) {
      finalArray.push(value);
    } else {
      finalArray.splice(finalArray.indexOf(value), 1);
    }
    return finalArray;
  };

  getDensities = (shanehs) => {
    if (this.state.densities.length === 0) {
      return [];
    } else if (shanehs.length === 0) {
      return this.state.densities;
    }

    let newDensities = [];
    let newSelectedDensities = [];
    if (shanehs.length === 0) {
      newDensities = densitiesList;
    } else {
      shanehs.forEach((shaneh) => {
        newDensities = newDensities.concat(shanehList[shaneh]);
      });
    }

    this.state.densities.forEach((density) => {
      if (newDensities.indexOf(density) !== -1) {
        newSelectedDensities.push(density);
      }
    });
    return newSelectedDensities;
  };

  shouldLoadMoreItems = () => {
    switch (this.state.activePartsTab) {
      case "border":
        return !this.state.borderItemsLoading && this.state.borderItemsHasMore;
      case "corner":
        return !this.state.cornerItemsLoading && this.state.cornerItemsHasMore;
      case "background":
        return (
          !this.state.backgroundItemsLoading &&
          this.state.backgroundItemsHasMore
        );
      case "afshan_background":
        return (
          !this.state.afshanBackgroundItemsLoading &&
          this.state.afshanBackgroundItemsHasMore
        );
      case "kheshti_background":
        return (
          !this.state.kheshtiBackgroundItemsLoading &&
          this.state.kheshtiBackgroundItemsHasMore
        );
      case "modern_background":
        return (
          !this.state.modernBackgroundItemsLoading &&
          this.state.modernBackgroundItemsHasMore
        );
      case "pattern":
        return (
          !this.state.modernPatternItemsLoading &&
          this.state.modernPatternItemsHasMore
        );
      case "toranj":
        return !this.state.toranjItemsLoading && this.state.toranjItemsHasMore;
      case "tile":
        return !this.state.tileItemsLoading && this.state.tileItemsHasMore;
      default:
        return true;
    }
  };

  itemsScrollHandler = () => {
    if (this.shouldLoadMoreItems()) {
      switch (this.state.activePartsTab) {
        case "border":
          this.setState(
            {
              borderItemsOffset:
                this.state.borderItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "corner":
          this.setState(
            {
              cornerItemsOffset:
                this.state.cornerItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "toranj":
          this.setState(
            {
              toranjItemsOffset:
                this.state.toranjItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "tile":
          this.setState(
            {
              tileItemsOffset:
                this.state.tileItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "background":
          this.setState(
            {
              backgroundItemsOffset:
                this.state.backgroundItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "afshan_background":
          this.setState(
            {
              afshanBackgroundItemsOffset:
                this.state.afshanBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "kheshti_background":
          this.setState(
            {
              kheshtiBackgroundItemsOffset:
                this.state.kheshtiBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "modern_background":
          this.setState(
            {
              moderniBackgroundItemsOffset:
                this.state.modernBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "pattern":
          this.setState(
            {
              moderniPatternItemsOffset:
                this.state.modernPatternItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        default:
          return;
      }
    }
  };

  resetParts = () => {
    this.setState({
      toranjItems: [],
      toranjItemsOffset: 0,
      toranjItemsError: false,
      toranjItemsHasMore: true,
      //// Border
      borderItems: [],
      borderItemsOffset: 0,
      borderItemsError: false,
      borderItemsHasMore: true,
      //// Background
      backgroundItems: [],
      backgroundItemsOffset: 0,
      backgroundError: false,
      backgroundItemsHasMore: true,
      //// Corner
      cornerItems: [],
      cornerItemsOffset: 0,
      cornerItemsError: false,
      cornerItemsHasMore: true,
      //// Tile
      tileItems: [],
      tileItemsOffset: 0,
      tileItemsError: false,
      tileItemsHasMore: true,
      //// Kheshti Background
      kheshtiBackgroundItems: [],
      kheshtiBackgroundItemsOffset: 0,
      kheshtiBackgroundItemsError: false,
      kheshtiBackgroundItemsHasMore: true,
      //// afshan Background
      afshanBackgroundItems: [],
      afshanBackgroundItemsOffset: 0,
      afshanBackgroundItemsError: false,
      afshanBackgroundItemsHasMore: true,
      //// Modern Background
      modernBackgroundItems: [],
      modernBackgroundItemsOffset: 0,
      modernBackgroundItemsError: false,
      modernBackgroundItemsHasMore: true,
      //// Modern Pattern
      modernPatternItems: [],
      modernPatternItemsOffset: 0,
      modernPatternItemsError: false,
      modernPatternItemsHasMore: true,
      lachakToranjSelectedParts: {
        type: "lachak-toranj",
        background: {},
        border: {},
        corner: {},
        toranj: {},
      },
      // Afshan States
      afshanSelectedParts: {
        type: "afshan",
        background: {},
        border: {},
      },
      // KHeshti States
      kheshtiSelectedParts: {
        type: "kheshti",
        background: {},
        tile: {},
      },

      // Modern States
      modernSelectedParts: {
        type: "modern",
        background: {},
        pattern: {},
      },
    });
  };

  filterChangeHandler = (type, id) => {
    this.resetParts();
    let newData;
    switch (type) {
      case "brands":
        newData = this.addOrRemoveFromArray(this.state.brands, id);
        this.setState({ brands: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      case "shanehs":
        newData = this.addOrRemoveFromArray(this.state.shanehs, id);
        // Remove densities that aren't allowed for current shanehs
        let newDensities = this.getDensities(newData);
        this.setState(
          { shanehs: newData, densities: newDensities, activeItems: [] },
          () => {
            this.loadAllParts();
          }
        );
        break;
      case "densities":
        newData = this.addOrRemoveFromArray(this.state.densities, id);
        this.setState({ densities: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      case "yarns":
        newData = this.addOrRemoveFromArray([], id);
        this.setState({ yarns: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });

        break;
      case "colors":
        newData = this.addOrRemoveFromArray(this.state.colors, id);
        this.setState({ colors: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      default:
        break;
    }
  };

  selectTabs = (tab) => {
    if (tab === "market_rug") {
      this.filterChangeHandler("yarns", 11);
    } else {
      this.filterChangeHandler("yarns", 12);
    }
    this.setState({ activeTabs: tab });
    this.props.changeRoute(tab);
  };
  selectTabInYourRug = (tab) => {
    this.setState({ activeTabInYourRug: tab });
  };

  render() {
    const { stepOnboarding, setStepOnboarding } = this.props;
    return (
      <div>
        <div className="container full-body mt-5">
          <div className="row">
            <div className="col-12 mb-5">
              <RugTabs
                stepOnboarding={stepOnboarding}
                activeTabs={this.state.activeTabs}
                selectTabs={this.selectTabs}
                texts={this.props.texts}
              />
              {this.state.activeTabs === "market_rug" && (
                <div className="text-center shadow-div">
                  <RugsFilterListSidebar
                    stepOnboarding={stepOnboarding}
                    globalState={this.state}
                    texts={this.props.texts}
                    filterChangeHandler={this.filterChangeHandler}
                    yarns={this.state.yarns}
                    densities={this.state.densities}
                    brands={this.state.brands}
                    shanehs={this.state.shanehs}
                    colors={this.state.colors}
                  />
                  <div className="rug-container align-items-center">
                    <RugPartsPanel
                      stepOnboarding={stepOnboarding}
                      texts={this.props.texts}
                      globalState={this.state}
                      carpetTypeHandler={this.carpetTypeHandler}
                      partsTabHandler={this.partsTabHandler}
                      partSelectHandler={this.partSelectHandler}
                      itemsScrollHandler={this.itemsScrollHandler}
                      themeDirection={this.props.globalState.themeDirection}
                    />

                    <div
                      className="rug-body"
                      style={{
                        zIndex: stepOnboarding === 4 ? 1 : 0,
                      }}
                    >
                      <CarpetBody
                        texts={this.props.texts}
                        globalState={this.state}
                        partsClearHandler={this.partsClearHandler}
                        filterChangeHandler={this.filterChangeHandler}
                      />
                    </div>
                  </div>

                  <div
                    className="w-100 d-flex"
                    style={{
                      zIndex: stepOnboarding === 5 ? 1 : 0,
                      position: stepOnboarding === 5 ? "relative" : "static",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: window.innerWidth < 768 ? 284 : 200,
                        display: stepOnboarding === 5 ? "block" : "none",
                        width: "100%",
                      }}
                    >
                      <p
                        className="text-center"
                        style={{
                          color: "#fff",
                          fontSize: window.innerWidth < 768 ? 16 : 24,
                          width: window.innerWidth < 768 ? "100%" : 435,
                        }}
                      >
                        در انتها می توانید به لیست مورد علاقه خود اضافه کنید تا
                        بتوانید فرش خود را پرو کنید
                      </p>
                    </div>
                    <div className=" w-100 d-flex favorite_container relative">
                      <button
                        className="btn-preview normal-add"
                        onClick={this.wishListHandler}
                      >
                        <span>{this.props.texts["addToWishList"]}</span>
                        <span> + </span>
                      </button>

                      <RugsWishListSidebar
                        texts={this.props.texts}
                        wishListHandler={this.wishListHandler}
                        wishList={this.state.rugsWishList}
                        activeTabs={this.state.activeTabs}
                      />
                    </div>
                  </div>
                </div>
              )}
              {this.state.activeTabs === "your_rug" && (
                <div className="text-center shadow-div">
                  <RugsFilterListSidebar
                    globalState={this.state}
                    texts={this.props.texts}
                    filterChangeHandler={this.filterChangeHandler}
                    yarns={this.state.yarns}
                    densities={this.state.densities}
                    brands={this.state.brands}
                    shanehs={this.state.shanehs}
                    colors={this.state.colors}
                  />
                  <div className="rug-container align-items-center">
                    <RugPartsPanel
                      stepOnboarding={stepOnboarding}
                      texts={this.props.texts}
                      globalState={this.state}
                      carpetTypeHandler={this.carpetTypeHandler}
                      partsTabHandler={this.partsTabHandler}
                      partSelectHandler={this.partSelectHandler}
                      itemsScrollHandler={this.itemsScrollHandler}
                      themeDirection={this.props.globalState.themeDirection}
                    />
                    <div
                      className="rug-body mt-4"
                      style={{
                        zIndex: stepOnboarding === 4 ? 1 : 0,
                      }}
                    >
                      <CarpetBody
                        texts={this.props.texts}
                        globalState={this.state}
                        partsClearHandler={this.partsClearHandler}
                        filterChangeHandler={this.filterChangeHandler}
                      />
                    </div>
                  </div>
                  <div className=" w-100 d-flex favorite_container relative">
                    <button
                      className="btn-preview normal-add"
                      onClick={this.wishListHandler}
                    >
                      <span>{this.props.texts["addToWishList"]}</span>
                      <span> + </span>
                    </button>

                    <RugsWishListSidebar
                      texts={this.props.texts}
                      wishListHandler={this.wishListHandler}
                      wishList={this.state.rugsWishList}
                      activeTabs={this.state.activeTabs}
                    />
                  </div>
                </div>
              )}
              {this.state.activeTabs === "your_pic" && (
                <div
                  className="text-center shadow-div"
                  style={{ position: "relative" }}
                >
                  <div
                    style={{
                      border: "1px solid #dfdede",
                      padding: "30px 20px",
                      borderRadius: 15,
                      marginBottom: 80,
                    }}
                  >
                    <YourRugTabs
                      activeTabs={this.state.activeTabInYourRug}
                      selectTabInYourRug={this.selectTabInYourRug}
                      texts={this.props.texts}
                    />
                    <div
                      className={`${
                        this.props.globalState.themeDirection == "ltr"
                          ? "your-rug-active-EN "
                          : "your-rug-active "
                      }  ${
                        this.state.activeTabInYourRug === "select_size"
                          ? "select-size"
                          : this.state.activeTabInYourRug === "select_pic"
                          ? "select-pic"
                          : this.state.activeTabInYourRug === "confirm_and_pay"
                          ? "confirm-and-pay"
                          : ""
                      }`}
                      themeDirection={this.props.globalState.themeDirection}
                    ></div>
                    {this.state.activeTabInYourRug === "select_size" && (
                      <SelectSize
                        texts={this.props.texts}
                        sizeList={this.state.rugsSizeList}
                        selectTabInYourRug={this.selectTabInYourRug}
                        selectedSizeRug={this.state.selectedSizeRug}
                        setSelectedSizeRug={(e) =>
                          this.setState({ selectedSizeRug: e })
                        }
                      />
                    )}

                    {this.state.activeTabInYourRug === "select_pic" && (
                      <SelectPic
                        texts={this.props.texts}
                        selectedSizeRug={this.state.selectedSizeRug}
                        selectTabInYourRug={this.selectTabInYourRug}
                        setUserInfo={(e) => this.setState({ userInfo: e })}
                        selectedRugPreview={this.state.selectedRugPreview}
                      />
                    )}
                    {this.state.activeTabInYourRug === "confirm_and_pay" && (
                      <ConfirmAndPay
                        texts={this.props.texts}
                        userInfo={this.state.userInfo}
                        setUserInfo={(e) => this.setState({ userInfo: e })}
                        selectedSizeRug={this.state.selectedSizeRug}
                        pay={() => this.requestRug()}
                        successPay={this.state.successPay}
                        trackingCode={this.state.trackingCode}
                        themeDirection={this.props.globalState.themeDirection}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
